module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-medusa.84dadbe2.png";